import { styled } from 'styled-components';

export const Wrapper = styled.div`
  padding: var(--spacing-medium);
`;
